/* eslint-disable */
import React, {useState} from "react";
/*component*/
import Modal from '../../component/Inc/Modal';
import Upload from '../../component/Inc/Upload';
import ClassRegister from "../../component/student/ClassRegister";

function PopPRClassRegister(props) {
  const { open, close } = props;
  const [radioChk, setRadioChk] = useState(0);
  const [successReportStep, setSuccessReportStep] = useState(0);
  return (
    <Modal open={open} close={close} type="pop_pr_class_register">
      <h2 className='pop_tit'>시범강의 보고서 등록</h2>
      <div className="content_container scroll">
        <div className='board_top'>
          <div className="check_wrap">
            <input type="radio" name="rdo" id="rdo_01" className="com_chk circle" />
            <label htmlFor="rdo_01" onClick={() => setRadioChk(0)}>성공</label>
            <input type="radio" name="rdo" id="rdo_02" className="com_chk circle"/>
            <label htmlFor="rdo_02" onClick={() => setRadioChk(1)}>실패</label>
            <input type="radio" name="rdo" id="rdo_03" className="com_chk circle"/>
            <label htmlFor="rdo_03" onClick={() => setRadioChk(2)}>취소</label>
            <input type="radio" name="rdo" id="rdo_04" className="com_chk circle"/>
            <label htmlFor="rdo_04" onClick={() => setRadioChk(3)}>연기</label>
          </div>
        </div>
        {radioChk === 0 ? (//성공
        <>
          {successReportStep === 0 ? (
            <>
            <Step setStep="step1"/>
            <div className="com_class_retister">
              <div className="layout">
                <div className="layout__inner">
                  <table className='com_board_list type_row'>
                    <colgroup>
                      <col width="140px"/><col width="474px"/>
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>이름</th>
                        <td className="td_left"><input type="text" className="input" defaultValue={`김학생`} /></td>
                      </tr>
                      <tr>
                        <th>학교</th>
                        <td>
                          <div className="com_input_wrap flex_row">
                            <select className="select">
                              <option value="서울">서울</option>
                            </select>
                            <select className="select">
                              <option value="경기 고등학교">경기 고등학교</option>
                            </select>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>생년월일 / 성별</th>
                        <td>
                          <div className="com_input_wrap flex_row">
                            <input type="date" className="input"/>
                            <div className="check">
                              <input type="radio" name="rdo" id="rdo_01" className="com_chk circle"/>
                              <label htmlFor="rdo_01">남</label>
                              <input type="radio" name="rdo" id="rdo_02" className="com_chk circle"/>
                              <label htmlFor="rdo_02">여</label>
                            </div>
                          </div>                 
                        </td>
                      </tr>
                      <tr>
                        <th>희망대 (학과)</th>
                        <td className="td_left">
                          <div className="com_input_wrap flex_between">
                            <div className="com_input_wrap flex_row">
                              <input type="text" className="input" placeholder="희망대 입력"/>
                              <input type="text" className="input" placeholder="희망학과 입력"/>
                              </div>
                            <button type="button" className="com_btn xs gray">+ 추가</button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>아이디</th>
                        <td className="td_left">asdkfsaj</td>
                      </tr>
                      <tr>
                        <th>비밀번호</th>
                        <td className="td_left">
                          <div className="com_input_wrap flex_between">
                            <span>@@1234</span>
                            <button type="button" className="com_btn xs gray">비밀 번호 변경 전송</button>
                          </div>                  
                        </td>
                      </tr>
                      <tr>
                        <th>입회일</th>
                        <td className="td_left"><input type="date" className="input"/></td>
                      </tr>
                      <tr>
                        <th>입회학년</th>
                        <td>
                          <div className="com_input_wrap flex_row">
                            <select>
                              <option>2021</option>
                            </select>
                            <select>
                              <option>중1</option>
                            </select>
                            <select>
                              <option>인문</option>
                            </select>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>현재 학년</th>
                        <td className="td_left">
                          <select className="select">
                            <option>중1</option>
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <th>현재 학년 사유</th>
                        <td className="td_left">
                          <select className="select">
                            <option>유급1년</option>
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <th>휴대폰</th>
                        <td className="td_left"><input type="text" className="input"/></td>
                      </tr>
                      <tr>
                        <th>이메일</th>
                        <td className="td_left">
                          <input type="text" className="input" />
                        </td>
                      </tr>
                      <tr>
                        <th>담임</th>
                        <td className="td_left">
                          <select className="select">
                            <option>담임선택</option>
                          </select>  
                        </td>
                      </tr>
                      <tr>
                        <th>특별관리회원</th>
                        <td>
                          <div className="com_input_wrap flex_row">
                            <input type="checkbox" className="com_chk" id="chk1"/><label htmlFor="chk1"/><input type="text" placeholder="사유입력"/>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>보호자 휴대폰</th>
                        <td className="td_left">
                          <div className="com_input_wrap flex_row">
                            <input type="radio" className="com_chk circle" id="phone_radio01" name="phone_radio"/><label htmlFor="phone_radio01">학부모</label>
                            <input type="radio" className="com_chk circle" id="phone_radio02" name="phone_radio"/><label htmlFor="phone_radio02">기타</label>
                            <input type="text" className="input ws"/><input type="text" className="input ws"/>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>보호자 메일</th>
                        <td className="td_left">
                          <input type="text" className="input" />
                        </td>
                      </tr>
                      <tr>
                        <th>홍보문자 수신</th>
                        <td  className="td_left">
                          <input type="radio" id="radio1_1" name="radio1" className="com_chk circle"/><label htmlFor="radio1_1">수신</label>
                          <input type="radio" id="radio1_2" name="radio1" className="com_chk circle"/><label htmlFor="radio1_2">거부</label>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="layout__inner">
                  <table className='com_board_list type_row'>
                    <colgroup>
                      <col width="140px"/><col width="474px"/>
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>생기부파일</th>
                        <td>
                          <div className="com_input_wrap flex_row">
                            <div className="com_input_upload">
                              <Upload title="파일 찾기" className="com_btn gray xs" type="has_input"/>
                            </div>
                            <button className="com_btn xs lightOrange btn_attatch_orange">생기부 파일 업로드링크 전송</button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>기타 파일</th>
                        <td>
                          <div className="com_input_wrap flex_row">
                            <div className="com_input_upload">
                              <Upload title="파일 찾기" className="com_btn gray xs" type="has_input"/>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>가상 계좌</th>
                        <td>
                          <div className="com_input_wrap flex_row">
                            <input type="text"/>
                            <button className="com_btn xs lightOrange btn_msg_orange">문자 전송</button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>환불 계좌</th>
                        <td>
                          <div className="com_input_wrap flex_row account_field">
                            <input type="text" className="name" />
                            <input type="text"/>
                          </div>                      
                        </td>
                      </tr>
                      <tr>
                        <th>주소</th>
                        <td>
                          <div className="com_input_wrap flex_row">
                            <input type="text" placeholder='주소' />
                            <button className="com_btn gray xs">우편번호</button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>상세주소</th>
                        <td>
                          <input type="text"/>
                        </td>
                      </tr>
                      <tr>
                        <th>약도</th>
                        <td>
                          <input type="text"/>
                        </td>
                      </tr>  
                      <tr>
                        <th>메모</th>
                        <td>
                          <textarea className="textarea"/>
                        </td>
                      </tr>
                      <tr>
                        <th>시범강의 일시</th>
                        <td>
                          <div className="com_input_wrap flex_row">
                            <input type="date"/>
                            <select className="select">
                              <option>20시</option>
                            </select>
                            <select className="select">
                              <option>10분</option>
                            </select>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>시범강의 장소</th>
                        <td>
                          <div className="com_input_wrap flex_row">
                            <input type="text" placeholder='주소' />
                            <button className="com_btn gray xs">우편번호</button>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>상세주소</th>
                        <td>
                          <input type="text"/>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            </>
          ) : successReportStep === 1 ? (
            <>
            <Step setStep="step2"/>
            <div className="com_class_retister">
              <div className="layout success_step2">
                <div className="layout__inner">
                  <table className='com_board_list type_row'>
                    <colgroup>
                      <col width="140px"/><col width="474px"/>
                    </colgroup>
                    <tbody>                      
                      <tr>
                        <th>고객성향 (학생)</th>
                        <td><textarea/></td>
                      </tr>
                      <tr>
                        <th>고객 성향 (학부모)</th>
                        <td><textarea/></td>
                      </tr>
                      <tr>
                        <th>요청 성별</th>
                        <td>
                          <div className="com_input_wrap">
                            <input type="radio" name="gender" id="gender-1" className="com_chk circle"/><label htmlFor="gender-1">상관없음</label>
                            <input type="radio" name="gender" id="gender-2" className="com_chk circle"/><label htmlFor="gender-2">남</label>
                            <input type="radio" name="gender" id="gender-3" className="com_chk circle"/><label htmlFor="gender-3">여</label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>요청 나이</th>
                        <td>
                          <div className="com_input_wrap flex_row">
                            <input type="radio" name="age" id="age-1" className="com_chk circle"/><label htmlFor="age-1">상관없음</label>
                            <input type="number"/>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>요청 학력</th>
                        <td><input type="text"/></td>
                      </tr>
                      <tr>
                        <th>담잉통보여부</th>
                        <td>
                          <div className="com_input_wrap">
                            <input type="checkbox" className="com_chk" id="chk01_1"/><label htmlFor="chk01_1">배정팀 통보</label>
                            <input type="checkbox" className="com_chk" id="chk01_2"/><label htmlFor="chk01_2">담임 통보</label>
                          </div>
                          <textarea/>
                        </td>
                      </tr>
                      <tr>
                        <th>학부모 중점사항</th>
                        <td><textarea/></td>
                      </tr>
                      <tr>
                        <th>담임 중점사항</th>
                        <td><textarea/></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="layout__inner">
                  <p className="com_sec_tit dot">과목 상태 입력</p>
                  {/*과목 추가 시 반복 start*/}
                  <table className='com_board_list type_row'>
                    <colgroup>
                      <col width="140px"/><col width="474px"/>
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>과목</th>
                        <td className="td_left">
                          <select className="select">
                            <option>국어</option>
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <th>수업방향</th>
                        <td>
                          <div className="com_input_wrap">
                            <input type="radio" id="radio2-1" name="radio2" className="com_chk"/><label htmlFor="radio2-1">내신</label>
                            <input type="radio" id="radio2-2" name="radio2" className="com_chk"/><label htmlFor="radio2-2">수능</label>
                            <input type="radio" id="radio2-3" name="radio2" className="com_chk"/><label htmlFor="radio2-3">내신+수능</label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>교과서</th>
                        <td>
                          <div className="com_input_wrap">
                            <input type="text" placeholder="출판서 명 입력" className="input"/>
                            <input type="text" placeholder="교과서 명 입력" className="input"/>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>선택과목</th>
                        <td>
                          <div className="com_input_wrap">
                            <input type="radio" id="radio3-1" name="radio3"  className="com_chk"/><label htmlFor="radio3-1">문학</label>
                            <input type="radio" id="radio3-2" name="radio3"  className="com_chk"/><label htmlFor="radio3-2">비문학</label>
                            <input type="radio" id="radio3-3" name="radio3"  className="com_chk"/><label htmlFor="radio3-3">화작</label>
                            <input type="radio" id="radio3-4" name="radio3" className="com_chk" /><label htmlFor="radio3-4">언애</label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>성적</th>
                        <td>
                          <div className="com_input_wrap flex_row">
                            <input type="text" className="input" placeholder="내신 성적"/>
                            <input type="number" className="input grade" placeholder="등급"/>
                            <span className="divider_line"></span>
                            <input type="text" className="input" placeholder="모의고사 성적"/>
                            <input type="number" className="input grade" placeholder="등급"/>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>학원</th>
                        <td>
                          <div className="com_input_wrap flex_row">
                            <input type="checkbox" className="com_chk" id="chk4"/><label htmlFor="chk4">병행</label>
                            <input type="text" placeholder="학원명 입력"/>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>이전과외</th>
                        <td>
                          <div className="com_input_wrap">
                            <input type="radio" id="radio4-1" name="radio4"  className="com_chk"/><label htmlFor="radio4-1">업체</label>
                            <input type="radio" id="radio4-2" name="radio4"  className="com_chk"/><label htmlFor="radio4-2">대학생</label>
                            <input type="radio" id="radio4-3" name="radio4"  className="com_chk"/><label htmlFor="radio4-3">개인과외</label>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <th>요구사항</th>
                        <td>
                          <textarea/>
                        </td>
                      </tr>
                      <tr>
                        <th>수업 가능시간</th>
                        <td className="td_left">
                          <div className="com_input_wrap flex_row">
                            <div className="com_check_date">
                              <input type="checkbox" className="chk_date" id="mon"/><label htmlFor="mon">월</label>
                              <input type="checkbox" className="chk_date" id="tue"/><label htmlFor="tue">화</label>
                              <input type="checkbox" className="chk_date" id="wed"/><label htmlFor="wed">수</label>
                              <input type="checkbox" className="chk_date" id="thu"/><label htmlFor="thu">목</label>
                              <input type="checkbox" className="chk_date" id="fri"/><label htmlFor="fri">금</label>
                              <input type="checkbox" className="chk_date" id="sat"/><label htmlFor="sat">토</label>
                              <input type="checkbox" className="chk_date" id="sun"/><label htmlFor="sun">일</label>
                            </div>
                          </div>
                          <div className="sel_time com_input_wrap flex_row">
                            <select className="select">
                              <option value="08시">08시</option>
                            </select>
                            <select className="select">
                              <option value="10분">10분</option>
                            </select>
                            <span className="txt">~</span>
                            <select className="select">
                              <option value="08시">08시</option>
                            </select>
                            <select className="select">
                              <option value="10분">10분</option>
                            </select>
                            <button className="btn_add"></button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {/*과목 추가 시 반복 end*/}
                  <button className="com_btn s full lightGray">+ 과목 추가</button>
                </div>
              </div>
            </div>
            </>
          ) : successReportStep === 2 ? (
            <>
            <Step setStep="step3"/>
            <ClassRegister/>
            </>
          ) : (<></> )}
          
        </>
        ) : radioChk === 1 ? (//실패
        <>
        <table className='com_board_list type_row'>
          <colgroup>
            <col width="140px"/><col />
          </colgroup>
          <tbody>
            <tr>
              <th>학생명 / 전화번호</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="text" className="input" defaultValue={`김학생`} />
                  <input type="text" className="input" defaultValue={`010-202-0000`} />
                </div>
              </td>
            </tr>
            <tr>
              <th>부모 폰</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="text" className="input" defaultValue={`부) 010-2020-2222`} />
                  <input type="text" className="input" defaultValue={`모) 010-2020-2222`} />
                </div>
              </td>
            </tr>
            <tr>
              <th>시범강의 일시</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <select className="select ws">
                    <option value="18시">18시</option>
                    <option value="17시">17시</option>
                  </select>
                  <select className="select ws">
                    <option value="30분">30분</option>
                    <option value="00분">00분</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <th rowSpan={2}>시범강의 장소</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="text" placeholder='주소' />
                  <button className="com_btn gray xs">우편번호</button>
                </div>
              </td>
            </tr>
            <tr>
              <td className="border_left">
                <input type="text" placeholder='주소' />
              </td>
            </tr>
          </tbody>
        </table>
        <p className="com_sec_tit dot">사유 입력</p>
        <table className='com_board_list type_row'>
          <colgroup>
            <col width="140px"/><col />
          </colgroup>
          <tbody>
            <tr>
              <th>상세상태</th>
              <td>
                <div className="com_input_wrap flex_column gap">
                  <p><input type="radio" name="radio22" id="radio22_1" className="com_chk circle"/><label htmlFor="radio22_1">취소 : 출발전 상담을 못 나감. (끝과 같음)</label></p>
                  <p><input type="radio" name="radio22" id="radio22_2" className="com_chk circle"/><label htmlFor="radio22_2">노쇼 : 현장에 도착했으나 연락이 안됨.</label></p>
                </div>
              </td>
            </tr>
            <tr>
              <th>내용 입력</th>
              <td>
                <textarea/>
              </td>
            </tr>
          </tbody>
        </table>
        </>
        ) : radioChk === 2 ? (//취소
        <>
        <table className='com_board_list type_row'>
          <colgroup>
            <col width="140px"/><col />
          </colgroup>
          <tbody>
            <tr>
              <th>학생명 / 전화번호</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="text" className="input" defaultValue={`김학생`} />
                  <input type="text" className="input" defaultValue={`010-202-0000`} />
                </div>
              </td>
            </tr>
            <tr>
              <th>부모 폰</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="text" className="input" defaultValue={`부) 010-2020-2222`} />
                  <input type="text" className="input" defaultValue={`모) 010-2020-2222`} />
                </div>
              </td>
            </tr>
            <tr>
              <th>시범강의 일시</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <select className="select ws">
                    <option value="18시">18시</option>
                    <option value="17시">17시</option>
                  </select>
                  <select className="select ws">
                    <option value="30분">30분</option>
                    <option value="00분">00분</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <th rowSpan={2}>시범강의 장소</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="text" placeholder='주소' />
                  <button className="com_btn gray xs">우편번호</button>
                </div>
              </td>
            </tr>
            <tr>
              <td className="border_left">
                <input type="text" placeholder='주소' />
              </td>
            </tr>
          </tbody>
        </table>
        <p className="com_sec_tit dot">사유 입력</p>
        <table className='com_board_list type_row'>
          <colgroup>
            <col width="140px"/><col />
          </colgroup>
          <tbody>
            <tr>
              <th>상세상태</th>
              <td>
                <div className="com_input_wrap flex_column gap">
                  <p><input type="radio" name="radio22" id="radio22_1" className="com_chk circle"/><label htmlFor="radio22_1">취소 : 출발전 상담을 못 나감. (끝과 같음)</label></p>
                  <p><input type="radio" name="radio22" id="radio22_2" className="com_chk circle"/><label htmlFor="radio22_2">노쇼 : 현장에 도착했으나 연락이 안됨.</label></p>
                </div>
              </td>
            </tr>
            <tr>
              <th>내용 입력</th>
              <td>
                <textarea/>
              </td>
            </tr>
          </tbody>
        </table>
        </>
        ) : radioChk === 3 ? (//연기
        <>
        <table className='com_board_list type_row'>
          <colgroup>
            <col width="140px"/><col />
          </colgroup>
          <tbody>
            <tr>
              <th>학생명 / 전화번호</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="text" className="input" defaultValue={`김학생`} />
                  <input type="text" className="input" defaultValue={`010-202-0000`} />
                </div>
              </td>
            </tr>
            <tr>
              <th>부모 폰</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="text" className="input" defaultValue={`부) 010-2020-2222`} />
                  <input type="text" className="input" defaultValue={`모) 010-2020-2222`} />
                </div>
              </td>
            </tr>
            <tr>
              <th>시범강의 일시</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <select className="select ws">
                    <option value="18시">18시</option>
                    <option value="17시">17시</option>
                  </select>
                  <select className="select ws">
                    <option value="30분">30분</option>
                    <option value="00분">00분</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <th rowSpan={2}>시범강의 장소</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="text" placeholder='주소' />
                  <button className="com_btn gray xs">우편번호</button>
                </div>
              </td>
            </tr>
            <tr>
              <td className="border_left">
                <input type="text" placeholder='주소' />
              </td>
            </tr>
          </tbody>
        </table>
        <p className="com_sec_tit dot">사유 입력</p>
        <table className='com_board_list type_row'>
          <colgroup>
            <col width="140px"/><col />
          </colgroup>
          <tbody>
            <tr>
              <th>상세상태</th>
              <td>
                <div className="com_input_wrap flex_column gap">
                  <p><input type="radio" name="radio23" id="radio23_1" className="com_chk circle"/><label htmlFor="radio23_1">연기 : 시강을 하지 않고 날짜가 연기 됨.</label></p>
                  <p><input type="radio" name="radio23" id="radio23_2" className="com_chk circle"/><label htmlFor="radio23_2">보류 : “생각할 시간을 달라“ 연락후 상태값 변경 가능.<br/>(보류 15일 이후 -> 담임 문자 전송 최종 처리 필요.)</label></p>
                </div>
              </td>
            </tr>
            <tr>
              <th>내용 입력</th>
              <td>
                <textarea/>
              </td>
            </tr>
            <tr>
              <th>연기 일시 입력</th>
              <td>
                <div className="com_input_wrap flex_row">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <select className="select ws">
                    <option value="18시">18시</option>
                    <option value="17시">17시</option>
                  </select>
                  <select className="select ws">
                    <option value="30분">30분</option>
                    <option value="00분">00분</option>
                  </select>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        </>
        ) : (<></> )}
      </div>
      <div className="btn_container">
        {radioChk === 0 ? (//성공
        <>
         {successReportStep === 0 ? (
          <>
            <button className="com_btn orange xs" onClick={()=>setSuccessReportStep(1)}>다음</button>
          </>
          ) : successReportStep === 1 ? (
            <>
            <button className="com_btn orange line xs" onClick={()=>setSuccessReportStep(0)}>이전</button>
            <button className="com_btn orange xs" onClick={()=>setSuccessReportStep(2)}>다음</button>
            </>
          ) : successReportStep === 2 ? (
            <>
            <button className="com_btn orange line xs" onClick={()=>setSuccessReportStep(1)}>이전</button>
            <button className="com_btn orange xs">등록</button>
            </>
          ) : (<></> )}
          <button className="com_btn gray right xs">임시저장</button>
        </>
        ) : radioChk === 1 ? (
          <><button className="com_btn orange xs">등록</button></>
        ) : radioChk === 2 ? (
          <><button className="com_btn orange xs">등록</button></>
        ) : radioChk === 3 ? (
          <><button className="com_btn orange xs">등록</button></>
        ) : (<></> )}
      </div>
    </Modal>
  );
}

const Step = (props) => {
  const {setStep} = props;
  return(
    <>
      <div className={`com_step ${setStep ? setStep : ``}`}>
        <p className="step">1. 학생정보 입력</p>
        <p className="step">2. 학생 내신정보 입력</p>
        <p className="step">3.  수업등록</p>
      </div>
    </>
  )
}

export default PopPRClassRegister;